import styled from 'styled-components'
import { Link } from 'react-router-dom'

export default function MainBannerItem({ type, externalLink, path, imageSrc }) {
  return type === 'redirect' ? (
    <Link to={path}>
      <BannerImgBlock>
        <BannerImage src={imageSrc} alt="" />
      </BannerImgBlock>
    </Link>
  ) : (
    <a href={externalLink} target="_blank">
      <BannerImgBlock>
        <BannerImage src={imageSrc} alt="" />
      </BannerImgBlock>
    </a>
  )
}

const BannerImgBlock = styled.div`
  width: 100%;
`

const BannerImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

/** <DotWrapper>{dots.map((value,index)=>{
                    let classVal = null;
                    if(value?.props?.className === "slick-active")
                    {
                        classVal="activated"
                    }
                    return (<BannerDot key={`main-banner-dot-${index}`} className={classVal}></BannerDot>);
                })}
                </DotWrapper>
            ) */
